import TextArea from 'antd/es/input/TextArea';
import { CustomInput } from 'components/custom';
import React, { useEffect, useState } from 'react';

type NewCalendarGeneralTabsProps = {
  addData?: (data: any) => void;
  data?: any;
  finalData?: any;
  errorName?: any;
};

const NewCalendarGeneralTabs = ({
  addData,
  data,
  finalData,
  errorName
}: NewCalendarGeneralTabsProps) => {
  const [incomingData, setIncomingData] = useState({});
  useEffect(() => {
    setIncomingData(data);
  }, [data]);
  return (
    <div style={{ marginTop: '50px', paddingBottom: '50px' }}>
      <section className={'function_container'}>
        <div style={{ background: 'white' }} className={'function_wrapper'}>
          <div>
            <div style={{ marginTop: '20px' }}>
              <CustomInput
                maxLength={100}
                disabled={data}
                background={data && '#f5f5f5'}
                value={data ? data?.name : finalData?.name}
                onChange={(e) => addData({ name: e?.target?.value })}
                required
                fontSize={'12px'}
                title="Name"
                error={errorName as string}
              />
            </div>
            <div>
              <TextArea
                className="remove_outline"
                autoSize={{ minRows: 7 }}
                maxLength={250}
                disabled={data}
                value={data ? data?.comment : finalData?.comment}
                onChange={(e) => addData({ comment: e?.target?.value })}
                placeholder="Comments"
                style={{
                  border: '0.5px solid #407FDD',
                  marginTop: 32,
                  background: 'white',
                  fontSize: '12px',
                  fontWeight: 500,
                  fontFamily: 'IBM Plex Serif'
                }}
                rows={6}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewCalendarGeneralTabs;
